import 'core-js/features/promise';
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import Vue2Filters from 'vue2-filters';

import '@/js/utilities/assign-polyfill';
import EventBus from '@/js/utilities/event-bus';
import { getMilitaryPayCalculatorConfig } from '@/js/api/calculator';

import 'vue-toast-notification/dist/index.css';

import '@/styles/main.scss';
import '@/styles/calculator.scss';

import createStore from './store';
import Hi3Wizard from './hi3-wizard';
import Hi3Print from './hi3-print';

Vue.use(VueToast, {
  position: 'top',
  duration: 5000,
});

Vue.use(Vue2Filters);

Vue.config.productionTip = false;

/**
 * mounts application to document
 * @param {*} preloadedState
 * @param {*} scripts
 */
export async function mount(preloadedState, scripts) {
  const config = await getMilitaryPayCalculatorConfig();
  const store = createStore(preloadedState, false, config);

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    store,
    render: (h) => h(Hi3Wizard),
  });

  EventBus.$on('print', (filter) => {
    const w = window.open();

    w.document.write('<html>'
    + '<head>'
    + '<title>Print - Military Pay Calc</title>'
    + '<style>'
    + 'body {'
      + 'font-family: Arial, Helvetica, sans-serif;'
    + '}'
    + 'section {'
      + 'border: solid 1px #1a4572;'
      + 'padding: 20px;'
    + '}'
    + 'section h1 {'
      + 'text-align: center;'
    + '}'
    + '.margin-top {'
      + 'margin-top: 25px;'
    + '}'
    + 'h1 {'
      + 'font-size: 2em;'
      + 'color: #333;'
      + 'margin-top: 0;'
    + '}'
    + 'h2 {'
      + 'font-size: 1.25em;'
      + 'color: #1a4572;'
    + '}'
    + 'h3 {'
      + 'font-size: 2em;'
      + 'color: #000;'
      + 'margin: 0.5em 0;'
    + '}'
    + 'ul {'
      + 'list-style: none;'
    + '}'
    + 'table {'
      + 'width: 100%;'
      + 'border-collapse: collapse;'
    + '}'
    + 'table td, table th {'
      + 'border: solid 1px #ddd;'
      + 'padding: 5px;'
    + '}'
    + '.row {'
      + 'display: flex;'
      + 'flex-direction: row;'
      + 'flex-wrap: wrap;'
      + 'width: 100%;'
    + '}'
    + '.col {'
      + 'display: flex;'
      + 'flex-direction: column;'
      + 'flex-basis: 100%;'
      + 'flex: 1;'
    + '}'
    + '.left {'
      + 'margin-right: 12px;'
    + '}'
    + '.right {'
      + 'margin-left: 13px;'
    + '}'
    + '.text-center {'
      + 'text-align: center;'
    + '}'
    + '</style>'
    + '</head>'
    + '<body style="width:1050px"><div id="app"></div>');
    scripts.forEach((s) => {
      w.document.write(`<script src="${s}"></script>`);
    });
    w.document.write('<script>'
      + 'window.addEventListener(\'message\', app.mountPopup);'
    + '</script>');
    w.document.write('</body></html>');

    w.postMessage({ state: store.state, filter }, window.location.origin); // NOSONAR
  });
}

export function mountPopup(e) {
  if (e.data) {
    const store = createStore(e.data.state, true);

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      store,
      render: (h) => h(Hi3Print, {
        props: {
          filter: e.data.filter,
        },
      }),
    });
  }
}
